<ng-container *ngIf="installation && errors">
    <div class="w-100 text-center">
        <pagination-controls id="page-re" style="text-align: center;" (pageChange)="pageChange($event)" previousLabel="Précédent"
            nextLabel="Suivant"></pagination-controls>
        <p>{{installation.machine.re_count}} rapports d'erreurs</p>
    </div>

    <ng-container
        *ngFor="let error of errors.re | paginate : {itemsPerPage: 30, currentPage: pre, totalItems: installation.machine.re_count, id:'page-re'}">
        <div class="w-100 report-item">
            <div [innerHTML]="error.content"></div>
        </div>
    </ng-container>
</ng-container>